import { render, staticRenderFns } from "./RelatorioInscricoesForm.vue?vue&type=template&id=a72a63a2&scoped=true&"
import script from "./RelatorioInscricoesForm.vue?vue&type=script&lang=js&"
export * from "./RelatorioInscricoesForm.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioInscricoesForm.vue?vue&type=style&index=0&id=a72a63a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72a63a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
